import useLeadsDescriptionQuery from "app/pages/sales-intelligence/modules/leads-search-filters/queries/useLeadsDescriptionQuery";
import { useOpportunityListContactsResults } from "app/pages/sales-intelligence/pages/opportunity-list/hooks/useOpportunityListContactsResults";
import useLeadsSearchResultsQueries from "app/pages/sales-intelligence/pages/opportunity-list/query/queries/useLeadsSearchResultsQueries";
import type { PageTabsConfig } from "app/pages/sales-intelligence/pages/opportunity-list/types/page-tabs";
import { useContactsStatusEffect } from "app/pages/sales-intelligence/sub-modules/contacts-search/hooks/useContactsStatusEffect";
import { useGetAllContactProfilesQuery } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/queries/useGetAllContactProfilesQuery";

const useTabsData = (tabsConfig: PageTabsConfig) => {
    useLeadsDescriptionQuery();
    useGetAllContactProfilesQuery();

    useLeadsSearchResultsQueries(tabsConfig);

    useOpportunityListContactsResults({ throwOnError: false });
    useContactsStatusEffect();
};

export default useTabsData;
